module.exports = __webpack_public_path__ + "static/img/Failed_1.b3469a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shipping/Failed_1.png
// module id = J0sC
// module chunks = 31